import * as React from 'react';
import { SVGProps } from 'react';

const SvgHamburger = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 16h14v2H5v-2zm0-5h14v2H5v-2zm0-5h14v2H5V6z" />
  </svg>
);

export default SvgHamburger;
